<template>
  <div id="app" ref="app">
    <Header v-if="!isMobile && showMobile >= 1366" />
    <MHeader v-else />
    <div :class="isMobile ? 'router-view mobile-view' : 'router-view'">
      <router-view />
    </div>
    <Footer v-if="!isMobile && showMobile >= 1366" />
    <MFooter v-else />
  </div>
</template>
<script>
import Footer from "./components/Footer.vue";
import Header from "./components/Header.vue";
import MHeader from "./components/mHeader.vue";
import MFooter from "./components/mFooter.vue";
import("./assets/styles/index.scss");
export default {
  name: "App",
  components: {
    Footer,
    Header,
    MHeader,
    MFooter,
  },
  data() {
    return {
      showMobile: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|Macintosh|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    },
  },
  mounted() {
    console.log(window.location.pathname + window.location.search, "dddddddd");
    console.log(window.location.href, "window.location.href");
    window.addEventListener("resize", this.checkWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkWidth);
  },
  methods: {
    checkWidth() {
      var pathAndQuery = window.location.pathname + window.location.search;
      if (window.innerWidth < 1366) {
        if (window.location.href.indexOf("/m") == -1) {
          if (pathAndQuery == "/") {
            window.location.href = window.location.href.replace(
              window.location.origin,
              window.location.origin + "/m"
            );
          } else {
            window.location.href = window.location.href.replace(
              window.location.origin + "/",
              window.location.origin + "/m-"
            );
          }
        }
      } else {
        if (window.location.href.indexOf("/m") != -1) {
          if (pathAndQuery.indexOf("/m-") != -1) {
            window.location.href = window.location.href.replace(
              window.location.origin + "/m-",
              window.location.origin + "/"
            );
          } else if (pathAndQuery == "/m") {
            window.location.href = window.location.href.replace(
              window.location.origin + "/m",
              window.location.origin + "/#/"
            );
          } else {
            window.location.href = window.location.href.replace(
              window.location.origin + "/m",
              window.location.origin
            );
          }
        }
      }
    },
  },
};
</script>

<style lang="less">
.router-view {
  width: 100%;
  margin: 0 auto;
  background-color: #f7faff;
}
.mobile-view {
  overflow: hidden;
}
</style>
